/**
 * Created by joerg on 30.05.17.
 */

import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import OutputModel from '../models/OutputModel'
import numeral from 'numeral/numeral'
import 'numeral/locales'


@observer
export default class OutPutComponent extends React.Component {
    render(){
    numeral.locale('de');
    var fval;
    if(this.props.outputModel.einheit === "€"){
         fval = numeral(Math.round(this.props.outputModel.value)).format('0,0[.]00 $');
    }else{
         fval = numeral(Math.round(this.props.outputModel.value)).format('0,0[.]00 ') +' '+ this.props.outputModel.einheit ;
    }
    let cl = this.props.classes || [];

        return (
        <div key={this.props.outputModel.key} className={"form-group outputcomponent " + cl.join(' ')}>
            <strong dangerouslySetInnerHTML={{__html: this.props.outputModel.headline}}></strong>
            <strong className="pull-right ">{fval}</strong>
        </div>);
    }
}
OutPutComponent.propTypes = {
    outputModel: PropTypes.instanceOf(OutputModel).isRequired,
    classes:PropTypes.array
};


// WEBPACK FOOTER //
// ./src/components/OutPutComponent.js